import { SettingsManager } from "./_settings_manager";
import { Modal } from "./_bootstrapModalExtensions";
import { InitKamara } from "./_editKamara";
import { isInputValueTrue } from "./app";

import { domtoimage } from 'dom-to-image';
import { saveAs } from 'file-saver';

declare global {
    export interface Window {
        ETDR_RD: any;
        ETDR: any;
        SettingsManager: SettingsManager;
        selectedState: any;
        selectedItemId: Object[];
        back: () => void;
        initEmailInputField: ($isMessageCheckBox, $emailWrapper) => void;
        initTypeSelector: ($type, $isApplicant, $isCorporation, $chamberRow) => void;
        initTypeSelectorForMultipleValues: ($type, $isApplicant, $isCorporation, $chamberRow, getMandatoryFieldsForExtendedPersonalData) => void;
        initPlannerHelper: ($iAmPlanner, $uniqueId, $chamberId, uniqueIdForCurrentUser, $phoneInputField, currentUserPhoneNumber) => void;
        updateRowCount: (rowCount) => void;
        updateRowCountForAffectedPersonList: (rowCount) => void;
        updateRowCountForAddresseeList: (rowCount) => void;
    }
}

window.ETDR_RD = {

    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),

    checkedItems: [],

    init: function () {
        window.ETDR_RD.adjustTables();
        window.ETDR_RD.stickyPanels();
        window.ETDR_RD.initInputDlgs();
        window.ETDR_RD.initFieldInputValidators();
        window.ETDR_RD.addEndCallbacks();
        window.ETDR_RD.initScreenShot();
    },

    addEndCallbacks: function () {
        for (let key in window) {
            if (typeof (MVCxClientGridView) != "undefined" && window[key] instanceof MVCxClientGridView) {
                let grid: MVCxClientGridView = window[key as string];
                if (this.checkedItems.indexOf(grid) === -1 && grid.hasOwnProperty('EndCallback')) {
                    this.checkedItems.push(grid);

                    grid.EndCallback.AddHandler(function () {
                        window.ETDR_RD.adjustTables();
                    });
                }
            } else if (typeof (MVCxClientPageControl) != 'undefined' && window[key] instanceof MVCxClientPageControl) {
                let control: MVCxClientPageControl = window[key as string];
                if (this.checkedItems.indexOf(control) === -1 && control.hasOwnProperty('ActiveTabChanged')) {
                    this.checkedItems.push(control);

                    control.ActiveTabChanged.AddHandler(function () {
                        window.ETDR_RD.addEndCallbacks();
                        window.ETDR_RD.adjustTables();
                    });
                }
            }
        }
    },

    initInputDlgs: function () {
        $(":input[data-val-required]:not([notrequired='True'])").addClass("required_field");
    },

    // Helpers can store the "show/hide" info locally in the local storage (because unique id logins can't save this info in the database).
    // we need to purge this also
    // The relevant data keys are always in the "skip-*" format
    resetLocalHelperData: function () {
        Object.keys(localStorage).forEach(function (key) {
            if (key.length > 5 && key.substring(0, 5) === "skip-") {
                localStorage.removeItem(key);
            }
        });

        return true;
    },

    initFieldInputValidators: function () {

        // Select the input fields with the allow-charater tag
        var nl = $("input[data-allow-character]");

        // Filter the keypress event, only allow the types defind in the allow-character attribute
        nl.keypress((event: JQuery.KeyPressEvent) => {

            if (event.which <= 31) {
                return true;
            }

            var $this = $(event.target);
            var allow = $this.data("allow-character").split(" ");

            var k = document.all ? event.keyCode : event.which;
            var char = String.fromCharCode(k);

            var ans = false;
            for (var i = 0; i < allow.length; ++i) {
                ans = ans || isAllowed(allow[i], char);
            }

            return ans;
        });

        // Check is the char is allowed by the defined rule
        // The rules are
        // number: 0-9
        // letter: hungarian letters, both capital and non capital
        // sign:   signs (/[,.:;-/']/)
        function isAllowed(type, char) {
            if (type === "letter") {
                return /[ a-zA-ZáÁéÉíÍóÓöÖőŐúÚüÜűŰ]/.test(char);
            }
            else if (type === "number") {
                return /[0-9]/.test(char);
            }
            else if (type === "sign") {
                return /[,.:;\-\/']/.test(char);
            }
            else {
                return false;
            }
        }
    },

    adjustTables: function () {
        $('.dxgvCSD:visible')
            .css({
                'min-height': '128px',
                'height': 'unset',
                'max-height': '512px'
            });
    },

    stickyPanels: function () {
        // sticky-kit is not a module (no exports, only augments the jQuery object)
        let stickyElement: any = $('.with-sticky__sticky');
        stickyElement.stick_in_parent();
    },

    initScreenShot: function () {

        $('#screenshot').click(function (e) {
            e.preventDefault();
            var now = new Date(),
                datetime = now.toString(),
                datetimeAsFileName = now.getFullYear() + '.' + ("0" + (now.getMonth() + 1)).slice(-2) + '.' + ("0" + now.getDate()).slice(-2) + '. ' + now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds();

            $('#client-datetime').html(datetime);
            $('body').addClass('screenshot');

            // Close the menu to prevent covering useful information on the page 
            $(this).closest(".dropdown-menu").prev().dropdown("toggle");

            // Js may not fetch the image
            $('body').find('img').each(function () {
                if ($(this).attr('src').match(/(^http|^www)/)) {
                    $(this).remove();
                }
            });

            domtoimage.toBlob(document.querySelector('body'))
                .then(function (blob) {
                    var filename = 'ETDR-' + datetimeAsFileName + '.png';
                    saveAs(blob, filename);

                    $('body').removeClass('screenshot');
                })
                .catch(function () {
                    $('body').removeClass('screenshot');
                });
        });
    }
};

window.back = function () {
    // IE, bool var, has to be defined
    if (navigator.appName == 'Microsoft Internet Explorer') {
        var newlocation = document.createElement('a');
        newlocation.href = document.referrer;
        document.body.appendChild(newlocation);
        newlocation.click();
    } else {
        window.location.href = document.referrer;
    }
};

window.initEmailInputField = function ($isMessageCheckBox, $emailWrapper) {

    function init() {
        if ($isMessageCheckBox.is(':checked')) {
            $emailWrapper.show();
        }
        else {
            $emailWrapper.hide();
        }
    }

    // $(init);
    $(function () {
        init();
    });

    $isMessageCheckBox.change(init);
};

window.initTypeSelector = function ($type, $isApplicant, $isCorporation, $chamberRow) {

    var defaultPartnerTypeForApplicant = window.ETDR_RD.appConfig["Constants.DefaultValueForApplicant"];
    var realPersonOnlyPartnerTypes = window.ETDR_RD.appConfig["Constants.RealPersonOnlyPartnerTypes"];
    var showChamberInputFor = window.ETDR_RD.appConfig["Constants.ShowChamberInputForPartnerTypes"];

    $(function () {
        onIsApplicantChanged();
        onTypeChanged();
    });

    $isApplicant.change(onIsApplicantChanged);
    $type.change(onTypeChanged);

    function onIsApplicantChanged() {

        if (isInputValueTrue($isApplicant)) {
            $type.val(defaultPartnerTypeForApplicant).change();
            $type.prop('disabled', true);
        }
        else {
            $type.prop('disabled', false);
        }
    }

    function onTypeChanged() {

        if (realPersonOnlyPartnerTypes.indexOf($type.val()) > -1) {

            // Ilyen típusú partner csak magánszemély lehet
            $isCorporation.prop('checked', false);
            $isCorporation.prop('disabled', true);
            $isCorporation.change();
        }
        else {
            // Ilyen típusú partner lehet magánszemély és jogi személy is
            $isCorporation.prop('disabled', false);
            $isCorporation.change();
        }

        // Csak az adott típusok esetén kell a kamarai adatokat megadni
        if (showChamberInputFor.indexOf($type.val()) > -1) {
            $chamberRow.show();
        }
        else {
            $chamberRow.hide();
        }
    }
};

window.initTypeSelectorForMultipleValues = function ($type, $isApplicant, $isCorporation, $chamberRow, getMandatoryFieldsForExtendedPersonalData) {

    var availableValues = window.ETDR_RD.appConfig["Constants.AvailableTypesForApplicant"];
    var realPersonOnlyPartnerTypes = window.ETDR_RD.appConfig["Constants.RealPersonOnlyPartnerTypes"];
    var showChamberInputFor = window.ETDR_RD.appConfig["Constants.ShowChamberInputForPartnerTypes"];
    var extendedMandatoryPersonalDataTypes = window.ETDR_RD.appConfig["Constants.ExtendedPersonalDataMandatoryForThesePartnerTypes"];

    $(function () {
        onIsApplicantChanged();

        // This is the inital page load, we have to show/hide certain fields (based on the type)
        // Hovewer, the validator states should be kept intact to give the user a chance to see the error messages
        onTypeChanged(false);
    });

    $isApplicant.change(onIsApplicantChanged);
    $type.change(function () { onTypeChanged(true); });

    function onIsApplicantChanged() {

        var isIVT = isInputValueTrue($isApplicant);

        $type.children('option').each(function () {
            this.disabled = isIVT && (jQuery.inArray(this.value, availableValues) === -1);
        });

        if (isIVT && (jQuery.inArray($type.val(), availableValues) === -1)) {
            $type.val(availableValues[0]).change();
        }
    }

    function onTypeChanged(resetValidators) {

        if (realPersonOnlyPartnerTypes.indexOf($type.val()) > -1) {

            // Ilyen típusú partner csak magánszemély lehet
            $isCorporation.prop('checked', false);
            $isCorporation.prop('disabled', true);
            $isCorporation.change();
        }
        else {
            // Ilyen típusú partner lehet magánszemély és jogi személy is
            $isCorporation.prop('disabled', false);
            $isCorporation.change();
        }

        // Csak az adott típusok esetén kell a kamarai adatokat megadni
        if (showChamberInputFor.indexOf($type.val()) > -1) {
            $chamberRow.show();
        }
        else {
            $chamberRow.hide();
        }

        // Certain partner types has extra requirements, a bunch of fields are mandatory (not that I agree with this decision)
        var $mandatoryFields = getMandatoryFieldsForExtendedPersonalData();
        if (extendedMandatoryPersonalDataTypes.indexOf($type.val()) > -1) {
            $mandatoryFields.attr('required', 'required');
            $mandatoryFields.addClass('required_field');
        }
        else {
            $mandatoryFields.removeAttr('required');
            $mandatoryFields.removeClass('required_field');

            $mandatoryFields.each(function () {
                $(this).rules('remove', 'required');
            });
        }

        if (resetValidators) {
            // Changing the applicant type has huge effects on the validators
            // (but the most annoying is that the previously required fields can loose requiredness)
            // Based on the following stackoverflow answer:
            // https://stackoverflow.com/questions/2086287/how-to-clear-jquery-validation-error-messages
            // First, we get the current form, since it contains the (already parsed) validation settings
            var $form = $type.closest('form');

            // .validate() is badly named, it is the "getValidator()" function
            var validator = $form.validate();

            // Manually remove every current error marker on the page
            // For some reason, the resetForm() later does not do this
            // Mark each field as successfully validated, then force-show the error messages (which we previously marked as successful)
            $('[name]', $form).each(function () {
                validator.successList.push(this);//mark as error free
            });
            // remove error messages if present
            validator.showErrors();

            // Reset the internal validator states
            // This is supposed to clean up the attached data tags and states
            validator.resetForm();
            validator.reset();

            // This is the internal name of the validator structure. Added by the raw jquery.validate plugin
            $form.removeData("validator")

            // Added by the jquery unobtrusive plugin
            $form.removeData("unobtrusiveValidation");

            // Finally, all previous validation-related thing is cleaned up. We can reparse the form. Good as new!
            $.validator.unobtrusive.parse($form);
        }
    }
};

window.initPlannerHelper = function ($iAmPlanner, $uniqueId, $chamberId, uniqueIdForCurrentUser, $phoneInputField, currentUserPhoneNumber) {

    $iAmPlanner.change(onIAmPlannerChanged);

    function onIAmPlannerChanged() {
        if ($iAmPlanner.is(":checked")) {
            $uniqueId.val(uniqueIdForCurrentUser).change();
            $phoneInputField.val(currentUserPhoneNumber);

            var url = window.ETDR_RD.appConfig["UrlAction.GetChamberMembershipInfoForCurrentUser"];

            $.getJSON(url, function (data) {
                if (!data || !data.HasChamberMembership) {
                    // Error cases, either no answer, or no applicable data returned (which should not happen, this function is only available after prechecking the conditions)
                    $('#planner-multiple-chamber-memberships').hide();

                    Modal.showAlertWindow('Nem sikerült a kamarai adatok betöltése', 'Hiba!');
                }
                else {
                    $uniqueId.prop('readonly', true);

                    if (data.HasMultipleChamberMemberships) {
                        $('#planner-multiple-chamber-memberships').show();
                    }
                    else {
                        $('#planner-multiple-chamber-memberships').hide();
                    }

                    // TODO: Kinda hack-ish solution, but there is no clear way to do this
                    // There is no universal identifier for the chamber fields and no generic JS to do the parsing
                    // Luckily the shortcomings also guarantee that it is only included once in the dom, so this solution will work
                    $("#KamaraiAzonosito").val(data.firstChamberMembership.Number);
                    $chamberId.val(data.firstChamberMembership.ChamberId);

                    InitKamara();
                }
            });
        }
        else {
            $uniqueId.val('').change();
            $uniqueId.prop('readonly', false);
            $('#planner-multiple-chamber-memberships').hide();
            $phoneInputField.val();
        }
    }
};

window.updateRowCount = function (rowCount) {
    $('.row-count').text(rowCount);
};

window.updateRowCountForAffectedPersonList = function (rowCount) {
    $('.row-count-affected').text(rowCount);
};

window.updateRowCountForAddresseeList = function (rowCount) {
    let pageControl: MVCxClientPageControl = window["editprocessAction"];

    if (pageControl) {
        pageControl.GetTabByName("addresseeTab").SetText("Címzettek (" + rowCount + ")");
    }
};
